import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet
} from 'react-native';

import {
    JDText,
    JDDialog,
    JDTouchable,
    JDImage
} from '@jdreact/jdreact-core-lib';

import { pt, complement } from '../../common/utils';
import QRCode from './QR-code';
import { post } from '../../common/fetch';

class OpeningHint extends PureComponent {
    state = {
        leftTime: new Date('2018/12/19 21:38:00').getTime() - new Date().getTime(),
        movieName: '你好吗你好吗你好吗',
        qrCodeUrl: 'https://img03.tooopen.com/uploadfile/downs/images/20110714/sy_20110714135215645030.jpg',
        ticketCode: '3243254325',
        ticketPwd: '24523452454325432',
        isList: false // 是否显示开场提示
    }

    static defaultProps = {
        isDialog: true // 是否是弹框
    }

    // componentDidMount() {
    //     this.hintStorage();
    // // }
    hintStorage = () => {
        openingHintTimerOne && clearTimeout(openingHintTimerOne);
        openingHintTimerTwo && clearInterval(openingHintTimerTwo);
        global.openingHintStorage.load({
            key: 'openningHintStatus'
        }).then(ret => {
            if (ret !== 'close' && this.props.isDialog) {
                this._getBegin();
            } else if (!this.props.isDialog) {
                this._getBegin();
            } else {
                this.setState({
                    isList: false
                });
            }
        }).catch(() => {
            this._getBegin();
        });
    }

    render() {
        const { isList, leftTime, movieName, qrCodeUrl, ticketCode, ticketPwd } = this.state;
        const { isDialog } = this.props;
        const { h, m, s } = this._resetTime(leftTime);

        if (isDialog) {
            return (
                isList
                    ? <JDDialog dialogStyle={ st.dialog }
                        show={ isList }
                        onClose={ () => this._closeDialog('isList') }
                        overlayClickable={ true }>
                        <View style={ st.red }>
                            <View style={ st.tip }>
                                <View style={ st.tip_top } />
                                <View style={ st.tip_bottom }>
                                    <View style={ st.tip_bottom_con }>
                                        <JDText style={ { color: '#252525', fontSize: pt(16) } }>
                                            {movieName ? (movieName.length > 8 ? movieName.substr(0, 7) + '...' : movieName) : ''} </JDText>
                                        <JDText style={ { color: '#666666', fontSize: pt(16) } }>将于</JDText>
                                        {h > 0 && <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                                            <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{this._convertNumber(h)}</JDText>
                                        </View>}
                                        {h > 0 && <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>小时</JDText>}
                                        <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                                            <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{this._convertNumber(m)}</JDText>
                                        </View>
                                        <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>分</JDText>
                                        <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                                            <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{this._convertNumber(s)}</JDText>
                                        </View>
                                        <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>秒</JDText>
                                        <JDText style={ { color: '#666666', fontSize: pt(16) } }>后放映</JDText>
                                    </View>
                                    <View style={ st.tip_bottom_con }>
                                        <JDText style={ { color: '#666666', fontSize: pt(16) } }>请及时兑票进场</JDText>
                                    </View>
                                </View>
                                <QRCode codeInfo={ { qrCodeUrl, ticketCode, ticketPwd } } />
                            </View>
                            <QRCode codeInfo={ { qrCodeUrl, ticketCode, ticketPwd } } />
                        </View>
                        <JDTouchable onPress={ () => this._closeDialog('isList') }
                            style={ { flexDirection: 'row', justifyContent: 'center', marginTop: pt(20) } }>
                            <View>
                                <JDImage style={ { width: pt(27), height: pt(27) } } source={ img.close } />
                            </View>
                        </JDTouchable>
                    </JDDialog>
                    : null
            );
        } else {
            return (
                isList
                    ? <View style={ st._red }>
                        <View style={ st.tip }>
                            <View style={ st.tip_top } />
                            <View style={ st.tip_bottom }>
                                <View style={ st.tip_bottom_con }>
                                    <JDText style={ { color: '#252525', fontSize: pt(16) } }>
                                        {movieName ? (movieName.length > 8 ? movieName.substr(0, 7) + '...' : movieName) : ''} </JDText>
                                    <JDText style={ { color: '#666666', fontSize: pt(16) } }>将于</JDText>
                                    {h > 0 && <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                                        <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{this._convertNumber(h)}</JDText>
                                    </View>}
                                    {h > 0 && <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>小时</JDText>}
                                    <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                                        <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{this._convertNumber(m)}</JDText>
                                    </View>
                                    <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>分</JDText>
                                    <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                                        <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{this._convertNumber(s)}</JDText>
                                    </View>
                                    <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>秒</JDText>
                                    <JDText style={ { color: '#666666', fontSize: pt(16) } }>后放映</JDText>
                                </View>
                                <View style={ st.tip_bottom_con }>
                                    <JDText style={ { color: '#666666', fontSize: pt(16) } }>请及时兑票进场</JDText>
                                </View>
                            </View>
                        </View>
                        <QRCode codeInfo={ { qrCodeUrl, ticketCode, ticketPwd } } />
                    </View>
                    : null
            );
        }
    }

    _closeDialog = key => {
        this.setState({
            [key]: false
        });
        global.openingHintStorage.save({
            key: 'openningHintStatus',
            data: 'close'
        });
        openingHintTimerOne && clearTimeout(openingHintTimerOne);
        openingHintTimerTwo && clearInterval(openingHintTimerTwo);
    }

    _cusCountDown = (countDownProps, leftTime) => {
        const hours = parseInt(leftTime / 60 / 60 / 1000);

        const minutes = parseInt(leftTime / 60 / 1000 - hours * 60);

        const seconds = parseInt((leftTime / 1000) - hours * 60 * 60 - (minutes * 60));

        // alert(leftTime);

        return (
            <View style={ { flexDirection: 'row' } }>
                {hours > 0
                    ? <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                        <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{complement(hours)}</JDText>
                    </View>
                    : null}
                {hours > 0 ? <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>小时</JDText> : null}
                <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                    <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{complement(minutes)}</JDText>
                </View>
                <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>分</JDText>
                <View style={ { width: pt(25), flexDirection: 'row', justifyContent: 'center' } }>
                    <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>{complement(seconds)}</JDText>
                </View>
                <JDText style={ { color: '#E2231A', fontSize: pt(16) } }>秒</JDText>
            </View>
        );
    }

    _timer = (leftTime) => {
        let _leftTime = leftTime;

        const { msLeft } = this._resetTime(leftTime);

        if (_leftTime <= 0) {
            this.setState({
                isList: false
            });

            return;
        }
        openingHintTimerOne = setTimeout(() => {
            _leftTime -= msLeft;
            this.setState({
                leftTime: _leftTime
            });
            openingHintTimerTwo = setInterval(() => {
                _leftTime -= 1000;
                if (_leftTime > 0) {
                    this.setState({
                        leftTime: _leftTime
                    });
                } else {
                    clearInterval(this.clock);
                    this.setState({
                        isList: false
                    });
                }
            }, 1000);
        }, msLeft);
    }

    _getBegin = () => {
        // this.setState({
        //     isList:true
        // });
        // this._timer(this.state.leftTime);

        post('getBegin').then(getBeginRes => {
            if (getBeginRes.data) {
                const {
                    leftTime,
                    movieName,
                    qrCodeUrl,
                    ticketCode,
                    ticketPwd
                } = getBeginRes.data;

                this.setState({
                    leftTime, // 锁座时间-当前时间
                    movieName,
                    qrCodeUrl,
                    ticketCode,
                    ticketPwd,
                    isList: true
                });
                this._timer(leftTime);
                this.props.openTip && this.props.openTip(false);
            } else {
                this.setState({
                    isList: false
                });
                this.props.openTip && this.props.openTip(true);
            }
        });
    }

    _convertNumber(x) {
        if (x > 9) {
            return x;
        } else {
            return `0${x}`;
        }
    }

    _resetTime = leftTime => {
        if (leftTime < 0 || leftTime === 0) {
            return {
                msLeft: 0,
                h: 0,
                m: 0,
                s: 0
            };
        }
        const hour_convert = 1000 * 60 * 60;
        const minunt_convert = 1000 * 60;
        const second_convert = 1000;

        const hours = Math.floor(leftTime / hour_convert);
        const minunts = Math.floor((leftTime - hours * hour_convert) / minunt_convert);
        const seconds = Math.floor((leftTime - hours * hour_convert - minunts * minunt_convert) / second_convert);
        const miliseconds = leftTime - hours * hour_convert - minunts * minunt_convert - seconds * second_convert;

        return {
            msLeft: miliseconds,
            h: hours,
            m: minunts,
            s: seconds
        };
    }
}

const img = {
    close: require('../../img/close_white.png')
};
const st = StyleSheet.create({
    dialog: {
        width: '94.67%',
        backgroundColor: 'transparent',
        borderWidth: 0,
        zIndex: 999
    },
    red: {
        borderRadius: pt(4),
        backgroundColor: '#fff'
    },
    _red: {
        marginLeft: '2.66%',
        marginBottom: pt(13),
        width: '94.68%',
        borderRadius: pt(4),
        backgroundColor: '#fff'
    },
    tip: {
        borderTopLeftRadius: pt(3),
        borderTopRightRadius: pt(3)
    },
    tip_top: {
        width: pt(355),
        height: pt(7),
        borderTopLeftRadius: pt(3),
        borderTopRightRadius: pt(3),
        backgroundColor: '#FF2000'
    },
    tip_bottom: {
        width: '100%',
        marginTop: pt(30),
        paddingBottom: pt(23)
    },
    tip_bottom_con: {
        flexDirection: 'row',
        justifyContent: 'center',
        height: pt(27),
        alignItems: 'center'
    }
});

export default OpeningHint;
